import { render, staticRenderFns } from "./ReLogin.vue?vue&type=template&id=2ac26bd7"
import script from "./ReLogin.vue?vue&type=script&lang=js"
export * from "./ReLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports